import FondInsertForm from "../../components/Fonds/FondInsertForm";
function FondAddPage(){
    return (
        <FondInsertForm   ></FondInsertForm>
    );
}
export default FondAddPage;